import React from 'react';
import { Tag } from 'antd';

/**
 * What a selected Skill Group does to a card or tab.
 *
 * Only the call-based figures can be narrowed to a set of skills: those show
 * the group's name. Everything else (people, schedules, monthly agent stats)
 * has nothing to do with skills and says so, rather than being hidden or
 * greyed out -- its numbers are still right for the campaign.
 *
 * Nothing at all without a group, so the page looks as it always has.
 */
export default function SkillGroupTag({ group, relevant, block = false }) {
  if (!group) return null;
  const tag = relevant
    ? <Tag color="blue" style={{ marginInlineEnd: 0 }}>Skill Group: {group.Name}</Tag>
    : <Tag style={{ marginInlineEnd: 0 }}>Skill Group Not Relevant</Tag>;
  return block ? <div style={{ marginBottom: 10 }}>{tag}</div> : tag;
}
